import Component from '@bythepixel/component-loader';
import Events from './events';
import Config from './config';

export default class PaginationLinks extends Component {
  static selector = '[data-comp-pagination-links]';

  constructor(containerEl, options = Config) {
    super(containerEl, options);

    this.paginationLinks = this.$container.querySelectorAll(
      options.selectors.paginationButton,
    );

    this.mount();
  }

  attachListeners() {
    this.paginationLinks.forEach((link) => {
      link.addEventListener('click', () => {
        window.dispatchEvent(Events.PaginationLinkClickedEvent);
      });
    });
  }

  mount() {
    this.attachListeners();
  }
}
